import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface RuntimeStateCardProps {
  title: string;
  body: string;
}

export function RuntimeStateCard({ title, body }: RuntimeStateCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">{body}</p>
      </CardContent>
    </Card>
  );
}
